import { render } from "./RevisionsGrid.vue?vue&type=template&id=038c520e"
import script from "./RevisionsGrid.vue?vue&type=script&lang=js"
export * from "./RevisionsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__